var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell"},[_c('van-field',_vm._b({on:{"click":_vm.handlClick},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'van-field',{
      ..._vm.fieldProps,
      readonly: true,
    },false)),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showPicker),callback:function ($$v) {_vm.showPicker=$$v},expression:"showPicker"}},[_c('van-picker',_vm._b({attrs:{"show-toolbar":"","columns":_vm.columns},on:{"confirm":_vm.onConfirm,"cancel":function($event){_vm.showPicker = false}}},'van-picker',_vm.pickerProps,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }